import React, {useState, useEffect, useContext} from 'react'
import '../App.scss'
import Map from './Map'
import axios from 'axios'
import ReactModal from "react-modal";
import {UserContext} from "./UserContext";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {accessToken} from "./tokens";
import {nationalParks} from "./utils/NationalParksUtils";
import nflTeams from "./utils/nflTeams";
import {countryList, formatDate, getBearerToken, getServerUrl, usStates} from "./utils/utils";
import Tooltip from "@mui/material/Tooltip";
import {Box, FormControl, MenuItem, Select} from "@mui/material";

function CreateActivity({open, onClose, tripId, tripLocation, tripCountry, tripState, trips, selectedCategory, selectedCategoryItem}) {
    const {user} = useContext(UserContext)
    const [name, setName] = useState('');
    const [location, setLocation] = useState("")
    const [category, setCategory] = useState(selectedCategory || "")
    const [categoryItem, setCategoryItem] = useState(selectedCategoryItem || "")
    const [categoryItemDetail1, setCategoryItemDetail1] = useState("")
    const [locationSearchResults, setLocationSearchResults] = useState([])
    const [country, setCountry] = useState(tripCountry)
    const [state, setState] = useState(tripState)
    const [nationalParkTrails, setNationalParkTrails] = useState([])
    const [selectedSearchLocation, setSelectedSearchLocation] = useState(null)
    const [selectedTrip, setSelectedTrip] = useState(null)


    const searchForLocation = (selectedLocation) => {
        fetch(`https://api.mapbox.com/search/searchbox/v1/suggest?q=${selectedLocation}&language=en&limit=5&access_token=${accessToken}&session_token=${user.id}`)
            .then(response => response.json())
            .then(data => {
                setLocationSearchResults(data.suggestions)
            })
    }

    useEffect(() => {
        if (category === "National Park" && categoryItem) {
            axios.get(`${getServerUrl()}/nationalPark/${categoryItem}`, {})
                .then(response => {
                    const nationalParkInfo = JSON.parse(JSON.stringify(response.data))
                    const trails = JSON.parse(nationalParkInfo?.trails)
                    const trailNameList = trails.features.map(trail => trail.properties.TRLNAME)

                    function onlyUnique(value, index, array) {
                        return array.indexOf(value) === index;
                    }

                    var uniqueTrailNames = trailNameList.filter(onlyUnique).sort();
                    setNationalParkTrails(uniqueTrailNames)
                })
        }
    }, [categoryItem])

    useEffect(() => {
        const searchLocations = setTimeout(() => {
            if (location) {
                searchForLocation(location)
            }
        }, 400)
        return () => clearTimeout(searchLocations)
    }, [location])

    const clearModal = () => {
        setName('');
        setLocation('')
        setCategory("")
        setCategoryItemDetail1("")
        setState('')
        setCountry('United States')
        setSelectedSearchLocation(null)
        setSelectedTrip(null)
    }


    const submitActivity = async () => {
        axios.post(`${getServerUrl()}/activity/create`, {
            name: name,
            location: location,
            category: category,
            categoryItem: categoryItem,
            categoryItemDetail1: categoryItemDetail1,
            country,
            state,
            tripId: tripId || selectedTrip
        }, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                Authorization: `Bearer ${await getBearerToken()}`
            }
        }).then(response => {
            clearModal()
            onClose(response.data)
        });
    }

    const createTripDisabled = !name || !location || !country || (country === 'United States' && !state)

    return (
        <ReactModal isOpen={open} className="create-activity-modal">
            <button id="go-home-button" onClick={() => {
                clearModal()
                onClose()
            }}>
                Close
            </button>
            {(tripId || selectedTrip) && (
                <div className="createTrip">

                    <div id="create-trip-info" style={{width: "100%"}}>
                        {/*<h1 style={{marginTop: 0}}> Create Activity</h1>*/}
                        <div style={{width: "calc(100% - 30px)"}}>
                            <Map location={selectedSearchLocation || tripLocation}/>
                        </div>
                        <div id="tripInfo">
                            <div className="tripTypeDiv">
                                <div className="parent-trip-input">
                                    <p className="required">Activity Name</p>
                                    <Autocomplete
                                        id="free-solo-demo"
                                        freeSolo
                                        filterOptions={(x) => x}
                                        options={[]}
                                        renderInput={(params) => <TextField {...params}
                                                                            label="Enter activity's name"/>}
                                        onInputChange={(event, newInputValue) => {
                                            setName(newInputValue)
                                        }}
                                        inputValue={name}
                                    />
                                </div>
                            </div>
                            <br/>
                            <div className="tripTypeDiv">
                                <div className="parent-trip-input">
                                    <p className="required">Location</p>
                                    <Autocomplete
                                        id="free-solo-demo"
                                        freeSolo
                                        filterOptions={(x) => x}
                                        options={locationSearchResults?.map(locationSearchResult => `${locationSearchResult.name} - ${locationSearchResult.place_formatted}`)}
                                        renderInput={(params) => <TextField {...params}
                                                                            label="Enter activity's location"/>}
                                        onInputChange={(event, newInputValue) => {
                                            setLocation(newInputValue)
                                            if (newInputValue.includes(" - ")) {
                                                setSelectedSearchLocation(newInputValue)
                                            }
                                            locationSearchResults?.forEach(locationSearchResult => {
                                                if (newInputValue.includes(" - ") && locationSearchResult.place_formatted === newInputValue.split(" - ")[1]) {
                                                    setCountry(locationSearchResult?.context?.country?.name || "United States")
                                                    setState(locationSearchResult?.context?.region?.name || "")
                                                }
                                            })
                                        }}
                                        inputValue={location}
                                    />
                                </div>
                            </div>
                            <div className="tripTypeDiv">
                                <div className="parent-trip-input">
                                    <p className="required">Country</p>
                                    <Autocomplete
                                        id="free-solo-demo"
                                        freeSolo
                                        filterOptions={(x) => x}
                                        options={countryList}
                                        renderInput={(params) => <TextField {...params}
                                                                            label="Enter country visited"/>}
                                        onInputChange={(event, newInputValue) => {
                                            setCountry(newInputValue)
                                        }}
                                        inputValue={country}
                                        style={{width: 200}}
                                    />
                                </div>
                            </div>
                            <div className="tripTypeDiv">
                                <div className="parent-trip-input">
                                    <p className="required">State</p>
                                    <Autocomplete
                                        id="free-solo-demo"
                                        freeSolo
                                        filterOptions={(x) => x}
                                        options={usStates}
                                        renderInput={(params) => <TextField {...params}
                                                                            label="Enter state visited"/>}
                                        onInputChange={(event, newInputValue) => {
                                            setState(newInputValue)
                                        }}
                                        inputValue={state}
                                        style={{width: 200}}
                                    />
                                </div>
                            </div>
                            <br/>
                            <br/>
                            <div className="category-div-container">
                                <Box display="flex" alignItems="center" gap={2} className="category-dropdown">
                                    <span>Category</span>
                                    <FormControl size="small" sx={{minWidth: 200}}>
                                        <Select
                                            value={category}
                                            onChange={e => setCategory(e.target.value)}
                                            displayEmpty
                                            inputProps={{'aria-label': 'Category'}}
                                            style={{background: "white"}}
                                        >
                                            {["", "National Park"].map(categoryItem => (
                                                <MenuItem value={categoryItem} disabled={categoryItem === ""}
                                                          key="categoryItem">
                                                    {categoryItem === "" ? "Select an activity category" : categoryItem}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                                {category === "National Park" && (
                                    <Box display="flex" alignItems="center" gap={2} className="category-dropdown">
                                        <span>National Park Visited</span>
                                        <FormControl size="small" sx={{minWidth: 200}}>
                                            <Select
                                                value={categoryItem}
                                                onChange={e => setCategoryItem(e.target.value)}
                                                displayEmpty
                                                inputProps={{'aria-label': 'Category'}}
                                                style={{background: "white"}}
                                            >
                                                {[{name: ""}, ...nationalParks].map(nationalPark => (
                                                    <MenuItem value={nationalPark.name}
                                                              disabled={nationalPark.name === ""}
                                                              key="categoryItem">
                                                        {nationalPark.name === "" ? "Select a National Park" : nationalPark.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                )}
                                {(category === "National Park" && categoryItem) && (
                                    <Box display="flex" alignItems="center" gap={2} className="category-dropdown">
                                        <span>National Park Trail Hiked</span>
                                        <FormControl size="small" sx={{minWidth: 200}}>
                                            <Select
                                                value={categoryItemDetail1}
                                                onChange={e => setCategoryItemDetail1(e.target.value)}
                                                displayEmpty
                                                inputProps={{'aria-label': 'Category'}}
                                                style={{background: "white"}}
                                            >
                                                {["", ...nationalParkTrails].map(trail => (
                                                    <MenuItem value={trail} disabled={trail === ""}
                                                              key="categoryItem">
                                                        {trail === "" ? "Select a Hiking Trail" : trail}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                )}
                            </div>
                        </div>
                        {createTripDisabled && (
                            <Tooltip title="You must fill out required fields to create trip">
                                <button onClick={submitActivity} style={{width: 200, opacity: 0.75}}
                                        disabled={createTripDisabled}>
                                    Create Activity!
                                </button>
                            </Tooltip>
                        )}
                        {!createTripDisabled && (
                            <button onClick={submitActivity} style={{width: 200}}
                            >
                                Create Activity!
                            </button>
                        )}
                    </div>
                </div>
            )}
            {(!tripId && !selectedTrip && trips?.length > 0) && (
                <div className="select-trip-activity-modal">
                    <Box display="flex" alignItems="center" gap={2} className="category-dropdown">
                        <span>Please select a trip: </span>
                        <FormControl size="small" sx={{minWidth: 200}}>
                            <Select
                                value={selectedTrip}
                                onChange={e => {
                                    setSelectedTrip(e.target.value)
                                    const selectedTripObject = trips.find(trip => trip.id === e.target.value)
                                    setCountry(selectedTripObject.country)
                                    setState(selectedTripObject.state)
                                    setLocation(selectedTripObject.location)
                                }}
                                displayEmpty
                                inputProps={{'aria-label': 'Category'}}
                                style={{background: "white"}}
                            >
                                {trips.map(trip => (
                                    <MenuItem value={trip.id} disabled={trip.name === ""}
                                              key="categoryItem">
                                        {`${trip.name} - ${trip.location} (${formatDate(trip.startDate)} - ${formatDate(trip.endDate)})`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </div>
            )}
            {(!tripId && !selectedTrip && trips?.length === 0) && (
                <div className="select-trip-activity-modal">
                   You have not created a trip for this National Park yet. Please create one and then try again.
                </div>
            )}
        </ReactModal>
    );
}

export default CreateActivity;
